import { getApplyLink } from '@nerdwallet/marketplace/selectors/common';
import { getIssuerName, getName } from '@nerdwallet/marketplace/selectors/mortgages';
var DEFAULT_APPLY_TEXT = 'Learn More';

var getIssuerAnnotation = function getIssuerAnnotation(marketplaceEntity) {
  var issuerName = getIssuerName(marketplaceEntity);
  return issuerName && "at ".concat(issuerName);
};

export default (function (_ref) {
  var marketplaceEntity = _ref.marketplaceEntity;
  var link = getApplyLink(marketplaceEntity);
  return {
    additionalEventData: {
      lender: getName(marketplaceEntity)
    },
    annotationText: getIssuerAnnotation(marketplaceEntity),
    link: link,
    text: DEFAULT_APPLY_TEXT,
    vertical: 'Mortgage Lender'
  };
});